//#region src/order_client_event_name.ts
var OrderClientEventName = /* @__PURE__ */ function(OrderClientEventName) {
	OrderClientEventName["DataScanAttempted"] = "data-scan-attempted";
	OrderClientEventName["SessionStart"] = "session-start";
	OrderClientEventName["SessionAbandon"] = "session-abandon";
	OrderClientEventName["SessionEnd"] = "session-end";
	OrderClientEventName["SessionExit"] = "session-exit";
	OrderClientEventName["CoverPromoClicked"] = "cover-promo-clicked";
	OrderClientEventName["FulfillmentOpeningStart"] = "fulfillment-opening-start";
	OrderClientEventName["FulfillmentOpeningCancel"] = "fulfillment-opening-cancel";
	OrderClientEventName["FulfillmentOpeningEnd"] = "fulfillment-opening-end";
	OrderClientEventName["MenuItemView"] = "menu-item-view";
	OrderClientEventName["MenuItemScan"] = "menu-item-scan";
	OrderClientEventName["MenuItemAbandon"] = "menu-item-abandon";
	OrderClientEventName["MenuItemAddToCart"] = "menu-item-add-to-cart";
	OrderClientEventName["MenuItemRemoveFromCart"] = "menu-item-remove-from-cart";
	OrderClientEventName["FulfillmentCheckoutStart"] = "fulfillment-checkout-start";
	OrderClientEventName["FulfillmentCheckoutCancel"] = "fulfillment-checkout-cancel";
	OrderClientEventName["FulfillmentCheckoutEnd"] = "fulfillment-checkout-end";
	OrderClientEventName["CheckoutStart"] = "checkout-start";
	OrderClientEventName["CheckoutCancel"] = "checkout-cancel";
	OrderClientEventName["CheckoutEnd"] = "checkout-end";
	OrderClientEventName["PaymentCreditCardStart"] = "payment-credit-card-start";
	OrderClientEventName["PaymentCreditCardCancel"] = "payment-credit-card-cancel";
	OrderClientEventName["PaymentCreditCardEnd"] = "payment-credit-card-end";
	OrderClientEventName["PaymentCreditCardError"] = "payment-credit-card-error";
	OrderClientEventName["OrderSendStart"] = "order-send-start";
	OrderClientEventName["OrderSendEnd"] = "order-send-end";
	OrderClientEventName["OrderSendError"] = "order-send-error";
	OrderClientEventName["OrderSendErrorOutOfSync"] = "order-send-error-out-of-sync";
	OrderClientEventName["OrderFailedToGet"] = "order-failed-to-get";
	OrderClientEventName["TipAdd"] = "tip-add";
	OrderClientEventName["TipRemove"] = "tip-remove";
	OrderClientEventName["TipEdit"] = "tip-edit";
	OrderClientEventName["TipViewRender"] = "tip-view-render";
	OrderClientEventName["TipViewDismiss"] = "tip-view-dismiss";
	OrderClientEventName["TipViewSuccess"] = "tip-view-success";
	OrderClientEventName["OrderSummaryStepViewRender"] = "order-summary-step-view-render";
	OrderClientEventName["OrderSummaryStepShowTipView"] = "order-summary-step-show-tip-view";
	OrderClientEventName["OrderSummaryStepOrderDidValidate"] = "order-summary-step-order-did-validate";
	OrderClientEventName["OrderSummaryStepTipDidValidate"] = "order-summary-step-tip-did-validate";
	OrderClientEventName["OrderSummaryStepEnableControlButtons"] = "order-summary-step-enable-control-buttons";
	return OrderClientEventName;
}(OrderClientEventName || {});
//#endregion
export { OrderClientEventName };

//# sourceMappingURL=order_client_event_name.js.map